import { useEffect, useState } from 'react';

export const DOCUMENT_SUBMENU_KEYS = {
  FORM_STATUS: 'formStatus',
  FORM_VALIDITY: 'formValidity',
};

const useDocumentMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
  const [openSubmenuKey, setOpenSubmenuKey] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSubmenuAnchorEl(null);
    setOpenSubmenuKey(null);
  };

  const handleSubmenuOpen = (key) => (event) => {
    event.stopPropagation();
    setSubmenuAnchorEl(event.currentTarget);
    setOpenSubmenuKey(key);
  };

  const handleSubmenuClose = () => {
    setSubmenuAnchorEl(null);
    setOpenSubmenuKey(null);
  };

  const isSubmenuOpen = (key) => openSubmenuKey === key && Boolean(submenuAnchorEl);

  useEffect(() => {
    if (!isMenuOpen) return undefined;

    const handlePointerDown = (event) => {
      if (anchorEl?.contains(event.target)) return;
      if (event.target.closest?.('[role="menu"]')) return;
      setAnchorEl(null);
      setSubmenuAnchorEl(null);
      setOpenSubmenuKey(null);
    };

    document.addEventListener('mousedown', handlePointerDown, true);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown, true);
    };
  }, [anchorEl, isMenuOpen]);

  return {
    anchorEl,
    handleMenuClose,
    handleMenuOpen,
    handleSubmenuClose,
    handleSubmenuOpen,
    isMenuOpen,
    isSubmenuOpen,
    submenuAnchorEl,
  };
};

export default useDocumentMenu;
